// Generated from b2bservices/src/common/productRequirements/types.ts.
// Do not edit. Run yarn requirements:sync in a paired checkout.

/** Native product values are heterogeneous; only each rule reads its own fields. */
export type ProductValues = { [field: string]: any };
export type ProductCategory = { id: string; name?: string };
export type CategoryNode = ProductCategory & { children?: CategoryNode[] };
export type ProductRetailer = 'apotea' | 'ica' | 'coop' | 'wolt' | 'mathem';

export type ProductFieldValidatorParams = {
  field: string;
  state?: ProductValues;
  productInfoFilesCount?: number;
};
export type ProductRuleParams = ProductFieldValidatorParams & {
  rootCategory?: CategoryNode;
  /** Names from the trusted category tree, never a supplier-provided sheet choice. */
  categoryPath?: readonly string[];
};
export type ProductFieldRule = {
  fields: string[];
  label: string;
  message?: string;
  organizations: 'base' | ProductRetailer[];
  categoryCondition?: (params: ProductRuleParams) => boolean;
  requireValidator?: (params: ProductFieldValidatorParams) => boolean;
  expandTreeViews?: { treeViewId: string; nodeId: string; forFields?: string[] }[];
};
export type ProductValidationError = {
  field: string;
  rule: ProductFieldRule;
  requiredBy: ProductRetailer[];
  message: string;
};
export type ProductValidations = {
  requiredFields: Record<string, ProductFieldRule>;
  errors: ProductValidationError[];
  missingFields: Record<string, string>;
};
export const MISSING_FIELD_ERROR = 'Vänligen fyll i detta fält eller spara som utkast.';
export const EMPTY_PRODUCT_VALIDATIONS: ProductValidations = { requiredFields: {}, errors: [], missingFields: {} };
